import styled from "styled-components";
import {DefaultStyle} from "../../assets/style/Style";


export const FeatureStyleTwoBase = styled.div`

  padding: ${DefaultStyle.sectionPaddingTopBottom} 0px;
  
  .fa{
    font-size: 6rem;
    color: ${DefaultStyle.secondary};
  }

`;
